import React from 'react';
import {
  Jumbotron, Row, Col, Image
} from 'react-bootstrap';
import { TronProps } from '../Components';


export const Tron = (tronProps: TronProps) => {
  const { title, description, body } = tronProps.tronProps;
  
  return (
    <Jumbotron fluid style={{ paddingLeft: '2em', paddingRight: '2em', paddingBottom: '1.5em', paddingTop: '.5em' }}>
      
      <Row>
        <Row>
          <Col className='col-md-2'>
            <Image src='../images/beta.png' height='50' alt='Beta' fluid/>
          </Col>
          <Col>
            <h5 style={{ backgroundColor: 'pink' }}>Please note that this application is written by Leon as a
              personal project and is not supported by VMware support.</h5>
            <h1 className='display-5' style={{ paddingTop: '0em' }}>{title}</h1>
            <h4>{description}</h4>
            {body}
          </Col>
        </Row>
      </Row>
    </Jumbotron>
  );
};

